// Forked into ../redesign/SharedComponents.tsx — keep in sync until phase_0 cleanup.
import styled from 'styled-components';
import { token } from '@bynder/design-system';
import { NavigableHeadingButton } from '../redesign/NavigableHeadingButton';
import { BannerNLS } from './BannerNLS';
import { Item } from '../redesign/Results/Item';
import { StyledHeadingInsideButton } from '../redesign/SharedComponents';

const HEADING_HEIGHT = 48;
const ITEMS_SECTION_HEIGHT = 184;

export const StyledResultsSection = styled.div<{ $noPaddingBottom?: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 0;
	padding: 0 0 ${({ $noPaddingBottom }) => ($noPaddingBottom ? '0' : '4px')};
	max-height: ${HEADING_HEIGHT + ITEMS_SECTION_HEIGHT}px;
	overflow: hidden;
`;

const HEADING_WRAPPER_MARGIN_TOP = 8;

export const StyledItemsUL = styled.ul`
	max-height: ${ITEMS_SECTION_HEIGHT}px;
	overflow-y: auto !important;
	margin-left: 0;
	position: relative;
`;

export const StyledTagsContainer = styled.div`
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
	align-items: center;
	justify-content: flex-start;
	padding: 4px 10px 8px;
	overflow-y: auto !important;
`;

export const StyledHeadingWrapper = styled.div<{ $noMarginTop?: boolean; $isActive?: boolean }>`
	margin: ${HEADING_WRAPPER_MARGIN_TOP}px 0 0px;
	margin-top: ${({ $noMarginTop }) => ($noMarginTop ? '0' : `${HEADING_WRAPPER_MARGIN_TOP}px`)};
	padding-bottom: 4px;
	width: 100%;
	position: relative;
	z-index: 1;
	background-color: ${({ $isActive }) => ($isActive ? token.gray25 : token.white)};

	${StyledResultsSection}:has(${StyledItemsUL}:hover) &,
	${StyledResultsSection}:has(${StyledTagsContainer}:hover) & {
		box-shadow: 0px 1px 0px 0px #0022330d, 0px 3px 6px 0px #0022330d;
	}
`;

// The old fork's look for the shared heading button: the redesign's wrapper has no margins,
// padding or scroll shadow, and its label is full width and medium weight.
export const ClassicNavigableHeadingButton = styled(NavigableHeadingButton)<{
	$noMarginTop?: boolean;
}>`
	margin: ${HEADING_WRAPPER_MARGIN_TOP}px 0 0px;
	margin-top: ${({ $noMarginTop }) => ($noMarginTop ? '0' : `${HEADING_WRAPPER_MARGIN_TOP}px`)};
	padding-bottom: 4px;

	${StyledResultsSection}:has(${StyledItemsUL}:hover) &,
	${StyledResultsSection}:has(${StyledTagsContainer}:hover) & {
		box-shadow: 0px 1px 0px 0px #0022330d, 0px 3px 6px 0px #0022330d;
	}

	${StyledHeadingInsideButton} {
		width: calc(100% + 6px);
		font-weight: inherit;
	}
`;

export const StyledHeadingNoButton = styled.div`
	padding: 0 ${token.spacing5};
	height: 32px;
	margin: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	font-size: 14px;
	font-weight: 500;
`;

export const StyledBadge = styled.div`
	padding: 2px 6px;
	border: 1px solid #0310262b;
	border-radius: 5px;
	font-size: 12px;
`;

export const StyledImgWrapper = styled.div`
	width: 40px;
	min-width: 40px;
	height: 40px;
	min-height: 40px;
	border-radius: 5px;
	border: 1px solid #d9dee1;
	background: rgba(0, 34, 51, 0.05);
	display: flex;

	& > img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	& > svg {
		width: 24px;
		height: 24px;
		display: block;
		margin: auto;
	}
`;

export const StyledInfoDiv = styled.div`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	justify-content: start;
	gap: 4px;
	flex: 1;
	min-width: 0;
`;

export const StyledParagraph = styled.div`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
`;

export const StyledViewAll = styled.div`
	color: ${token.colorTextDisabled};

	> span:first-child {
		color: ${token.colorTextMuted};
	}
`;

// The old fork's look for the shared NLS banner: tighter margins and padding, design-system radius.
export const ClassicBannerNLS = styled(BannerNLS)`
	margin: ${token.spacing4};
	padding: ${token.spacing4};
	border-radius: ${token.radiusLarge};
`;

// The old fork's look for the shared result row: content-width, even padding, rounded corners.
export const ClassicItem = styled(Item)`
	width: auto;
	padding: ${token.spacing3};
	border-radius: ${token.radiusLarge};
`;
